<div
    class="creative"
    [ngClass]="{ transparent: transparent }"
    #creative></div>

<social-overlay></social-overlay>
